import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-slate-800 text-slate-200 py-5 mt-12 border-t-[3px] border-blue-500 dark:bg-slate-900 dark:border-gold">
      <div className="max-w-6xl mx-auto px-5 flex justify-between items-center flex-wrap gap-4 md:flex-row flex-col text-center md:text-left">
        <div>
          <p className="m-0 text-sm">&copy; {new Date().getFullYear()} Timm Buse - Turnierverwaltung</p>
        </div>
        <div className="flex items-center gap-2.5">
          <Link to="/impressum" className="text-slate-200 no-underline text-sm transition-colors hover:text-blue-400 hover:underline dark:hover:text-gold">
            {t('footer.impressum')}
          </Link>
          <span className="text-slate-500">|</span>
          <Link to="/datenschutz" className="text-slate-200 no-underline text-sm transition-colors hover:text-blue-400 hover:underline dark:hover:text-gold">
            {t('footer.datenschutz')}
          </Link>
          <span className="text-slate-500">|</span>
          <Link to="/kontakt" className="text-slate-200 no-underline text-sm transition-colors hover:text-blue-400 hover:underline dark:hover:text-gold">
            {t('footer.kontakt')}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
